@if (enabled()) {
  <a
    [routerLink]="path()"
    (click)="deactivate()"
    routerLinkActive="active"
    (isActiveChange)="active.set($event)"
    [queryParams]="queryParams()"
    >{{ label() }}</a
  >
}
